var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#7500C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 20.8V5.97647C3 5.43294 3.18537 4.96781 3.55611 4.58108C3.92747 4.19369 4.37368 4 4.89474 4H16.2632C16.7842 4 17.2304 4.19369 17.6018 4.58108C17.9725 4.96781 18.1579 5.43294 18.1579 5.97647V10.9918C18 10.9588 17.8462 10.9381 17.6965 10.9295C17.5462 10.9216 17.3842 10.9176 17.2105 10.9176C17.0368 10.9176 16.8752 10.9216 16.7255 10.9295C16.5752 10.9381 16.4211 10.9588 16.2632 10.9918V5.97647H4.89474V16.0318L5.06053 15.8588H11.5974C11.5658 16.0235 11.5459 16.1843 11.5377 16.3411C11.5301 16.4972 11.5263 16.6659 11.5263 16.8471C11.5263 17.0282 11.5301 17.1969 11.5377 17.353C11.5459 17.5098 11.5658 17.6706 11.5974 17.8353H5.84211L3 20.8ZM6.78947 9.92941V7.95294H14.3684V9.92941H6.78947ZM6.78947 13.8824V11.9059H11.5263V13.8824H6.78947ZM16.2632 20.8V17.8353H13.4211V15.8588H16.2632V12.8941H18.1579V15.8588H21V17.8353H18.1579V20.8H16.2632Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup20);
export default __webpack_public_path__ + "static/media/Group 20.d6cc9200e3ddc204e1ca918748e55bda.svg";
export { ForwardRef as ReactComponent };